import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=fe08e146&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=fe08e146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe08e146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe08e146')) {
      api.createRecord('fe08e146', component.options)
    } else {
      api.reload('fe08e146', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=fe08e146&scoped=true&", function () {
      api.rerender('fe08e146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-221WAjsK73v1i/JS/comp/CookieBox.vue"
export default component.exports